import { usePage } from '@inertiajs/inertia-react'
import Grid from '@mui/material/Grid'

import { useState } from 'react'
import CampaignRequestedDetail from './CampaignRequestedDetail'
import CampaignRequestedVouchers from './CampaignRequestedVouchers'

const CampaignRequestedShow = () => {
  const {
    props: { requestedCampaign, voucherByType },
  } = usePage()
  const [data, setData] = useState(requestedCampaign)

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <CampaignRequestedDetail requestedCampaign={data} setData={setData} voucherByType={voucherByType} />
      </Grid>

      <Grid item xs={12}>
        <CampaignRequestedVouchers />
      </Grid>
    </Grid>
  )
}

export default CampaignRequestedShow
